import Login from 'modules/authentication/components/Login';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'slices/app/store/store'; 


const LoginRedirectWrapper = () => {
  const user = useSelector((state: RootState) => state.Login.user);
  const token = localStorage.getItem("token");
  const userProfile = localStorage.getItem("authPOSUser");

  if (user && token && userProfile) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Login />;
};

export default LoginRedirectWrapper;
